export const printFunction = () => {
  const element = document.getElementById("printableArea");
  if (!element) return;

  const iframe = document.createElement("iframe");
  Object.assign(iframe.style, {
    position: "fixed",
    right: "0",
    bottom: "0",
    width: "0",
    height: "0",
    border: "0",
  });

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;

  const header = element.querySelector(".print-header")?.innerHTML || "";
  const footer = element.querySelector(".print-footer")?.innerHTML || "";
  const contentElements = element.querySelectorAll(".print-content");
  const content = Array.from(contentElements)
    .map(el => el.outerHTML)
    .join("");

  iframeDoc.open();
  iframeDoc.write(`
    <html>
      <head>
        <title>Report</title>
        <style>
          @page {
            size: A4;
            padding: 15mm;
          }

          @media print {
            body {
              counter-reset: page;
            }

            .print-body::before {
              content: "";
              display: block;
              height: 80px; /* SAME as header space */
            }

            .print-body::after {
              content: "";
              display: block;
              height: 60px; /* SAME as footer space */
            }
          }

          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }

          html, body {
            height: 100%;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 8.5pt;
            color: #000;
            background: #fff;
          }

          /* ================= HEADER ================= */
          .fixed-header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            background: white;
          }

          /* ================= FOOTER ================= */
          .fixed-footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
          }

          .page-table {
            width: 100%;
            height: 100%
            border-collapse: collapse;
          }

          .page-table .page-head {
            display: table-header-group;
          }

          .page-table .page-body {
            height: 100%;
          }

          .page-table .page-footer {
            display: table-footer-group;
          }

          .page-table tr {
            page-break-inside: avoid;
          }

          /* ================= CONTENT ================= */
          .print-body {
            padding-top: 80px;
            padding-bottom: 60px;
          }

          /* Header */
          .hdr-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 5px;
          }

          .hdr-table td {
            border: none;
            padding: 0;
            vertical-align: top;
          }

          .co-name {
            font-size: 15pt;
            font-weight: bold;
            line-height: 1.1;
          }

          .rpt-sub {
            font-size: 9pt;
            font-weight: 500
            color: #444;
            margin-top: 3px;
          }

          .hdr-meta { 
            font-size: 8pt; 
            color: #444; 
            text-align: right; 
            line-height: 1.2;
            vertical-align: bottom; 
          }

          /* Dividers */
          .rule-thick {
            border-top: 2px solid #1a1a1a;
            margin-bottom: 2px;
          }

          .rule-thin {
            border-top: 1px solid #bbb;
            margin-bottom: 8px;
          }

          .rule-foot {
            border-top: 1px solid #bbb;
            padding-top: 5px;
          }

          .info-row {
            display: flex;
            gap: 25px;
            margin-bottom: 10px;
            padding: 8px 10px;
            background: #f5f5f5;
            border-left: 3px solid #1a1a1a;
          }

          .info-row .info-label {
            font-size: 7.5pt;
            font-weight: 500;
            color: #444;
          }
          .info-row .info-value {
            font-size: 9pt;
            font-weight: 600;
            color: #1a1a1a;
            margin-top: 3px;
          }

          /* Table */
          .data-tbl {
            width: 100%;
            border-collapse: collapse;
            font-size: 8pt;
            table-layout: fixed;
          }

          .data-tbl th {
            background: #d1d5dc !important;
            color: #1a1a1a !important;
            font-weight: 600;
            font-size: 7.5pt;
            padding: 6px 5px;
            border-right: 1px solid #d1d5dc;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .data-tbl td {
            padding: 8px 5px;
            border-bottom: 1px solid #ddd;
            word-break: break-word;
            font-size: 9px;
          }

          .data-tbl tr {
            page-break-inside: avoid;
          }

          /* Footer */
          .foot-tbl {
            width: 100%;
            border-collapse: collapse;
          }

          .foot-tbl td {
            border: none;
            font-size: 7pt;
            color: #888;
          }

          .print-content + .print-content {
            margin-top: 20px;
          }

          /* Total Section */
          .total-section {
            display: table;
            width: 100%;
            margin-top: 4px;
          }

          .total-tbl {
            width: 42%;
            border-collapse: collapse;
            font-size: 8.5pt;
            border: 1px solid #ddd;
            margin-left: auto;
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .total-tbl tr {
            border-bottom: 1px solid #ddd;
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .total-tbl td {
            padding: 6px 10px;
          }

          .total-label {
            width: 65%;
            font-size: 8pt;
            font-weight: 500;
            color: #1a1a1a;
            background: #f5f5f5;
            border-right: 2px solid #ddd;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .total-value {
            width: 35%;
            text-align: right;
            font-weight: 600;
            color: #1a1a1a;
            font-size: 8.5pt;
          }

          /* Grand Total Row */
          .grand-total-row {
            border-top: 2px solid #ddd !important;
          }

          .grand-total-row .total-label {
            background: #d1d5dc !important;
            font-size: 8.5pt;
            font-weight: 700;
            color: #1a1a1a;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .grand-total-row .total-value {
            background: #d1d5dc !important;
            font-size: 9pt;
            font-weight: 700;
            color: #1a1a1a;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        </style>
      </head>

      <body>

        <table class="page-table">
          <thead class="page-head">
            <tr>
              <td>
                <!-- HEADER -->
                ${header}
              </td>
            </tr>
          </thead>

          <tbody class="page-body">
            <tr>
              <td>
                <!-- CONTENT -->
                ${content}
              </td>
            </tr>
          </tbody>

        </table>

      </body>
    </html>
  `);

  iframeDoc.close();

  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  }, 500);
};

export const printLandscapeFunction = () => {
  const element = document.getElementById("printableArea");
  if (!element) return;

  const iframe = document.createElement("iframe");

  Object.assign(iframe.style, {
    position: "fixed",
    right: "0",
    bottom: "0",
    width: "0",
    height: "0",
    border: "0",
  });

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;

  const header = element.querySelector(".print-header")?.innerHTML || "";
  const footer = element.querySelector(".print-footer")?.innerHTML || "";
  const contentElements = element.querySelectorAll(".print-content");

  const content = Array.from(contentElements)
    .map((el) => el.outerHTML)
    .join("");

  iframeDoc.open();
  iframeDoc.write(`
    <html>
      <head>
        <title>Report</title>
        <style>
          @page {
            size: A4 landscape;
            margin: 12mm;
          }

          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 8.5pt;
            color: #000;
            background: #fff;
            padding: 12mm;
          }

          /* ================= HEADER ================= */
          .fixed-header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            background: white;
            padding: 12mm 12mm 0;
          }

          /* ================= FOOTER ================= */
          .fixed-footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            padding: 0 12mm 12mm;
          }

          /* ================= CONTENT ================= */
          .print-body {
            margin-top: 15mm;
            margin-bottom: 15mm;
          }

          .hdr-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 5px;
          }

          .hdr-table td {
            border: none;
            padding: 0;
            vertical-align: top;
          }

          .co-name {
            font-size: 15pt;
            font-weight: bold;
            line-height: 1.1;
          }

          .rpt-sub {
            font-size: 9pt;
            font-weight: 500;
            color: #444;
            margin-top: 3px;
          }

          .hdr-meta {
            font-size: 8pt;
            color: #444;
            text-align: right;
            line-height: 1.2;
            vertical-align: bottom;
          }

          .rule-thick {
            border-top: 2px solid #1a1a1a;
            margin-bottom: 2px;
          }

          .rule-thin {
            border-top: 1px solid #bbb;
            margin-bottom: 8px;
          }

          .rule-foot {
            border-top: 1px solid #bbb;
            padding-top: 5px;
          }

          .info-row {
            display: flex;
            gap: 25px;
            margin-bottom: 10px;
            padding: 8px 10px;
            background: #f5f5f5;
            border-left: 3px solid #1a1a1a;
          }

          .info-row .info-label {
            font-size: 7.5pt;
            font-weight: 500;
            color: #444;
          }

          .info-row .info-value {
            font-size: 9pt;
            font-weight: 600;
            color: #1a1a1a;
            margin-top: 3px;
          }

          /* ================= TABLE ================= */
          .data-tbl {
            width: 100%;
            border-collapse: collapse;
            font-size: 8pt;
            table-layout: fixed;
          }

          .data-tbl th {
            background: #d1d5dc !important;
            color: #1a1a1a !important;
            font-weight: 600;
            font-size: 7.5pt;
            padding: 6px 5px;
            border-right: 1px solid #d1d5dc;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .data-tbl td {
            padding: 8px 5px;
            border-bottom: 1px solid #ddd;
            word-break: break-word;
            font-size: 9px;
          }

          .data-tbl tr {
            page-break-inside: avoid;
          }

          /* ================= FOOTER ================= */
          .foot-tbl {
            width: 100%;
            border-collapse: collapse;
          }

          .foot-tbl td {
            border: none;
            font-size: 7pt;
            color: #888;
          }

          .print-content + .print-content {
            margin-top: 20px;
          }

          /* ================= TOTAL SECTION ================= */
          .total-section {
            display: flex;
            justify-content: flex-end;
            margin-top: 4px;
          }

          .total-tbl {
            width: 30%;
            border-collapse: collapse;
            font-size: 8.5pt;
            border: 1px solid #ddd;
          }

          .total-tbl tr {
            border-bottom: 1px solid #ddd;
          }

          .total-tbl td {
            padding: 6px 10px;
          }

          .total-label {
            width: 65%;
            font-size: 8pt;
            font-weight: 500;
            color: #1a1a1a;
            background: #f5f5f5;
            border-right: 2px solid #ddd;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .total-value {
            width: 35%;
            text-align: right;
            font-weight: 600;
            color: #1a1a1a;
            font-size: 8.5pt;
          }

          .grand-total-row {
            border-top: 2px solid #ddd !important;
          }

          .grand-total-row .total-label,
          .grand-total-row .total-value {
            background: #d1d5dc !important;
            font-weight: 700;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        </style>
      </head>

      <body>
        <div class="fixed-header">
          ${header}
        </div>

        <div class="print-body">
          ${content}
        </div>
      </body>
    </html>
  `);

  iframeDoc.close();

  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  }, 500);
};

export const printReqFunction = () => {
  const element = document.getElementById("printableArea");
  if (!element) return;

  const iframe = document.createElement("iframe");
  Object.assign(iframe.style, {
    position: "fixed",
    right: "0",
    bottom: "0",
    width: "0",
    height: "0",
    border: "0",
  });

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;

  const contentElements = element.querySelectorAll(".print-content");
  const content = Array.from(contentElements)
    .map(el => el.outerHTML)
    .join("");

  iframeDoc.open();
  iframeDoc.write(`
    <html>
      <head>
        <title>Report</title>
        <style>
          @page {
            size: A4;
            padding: 15mm;
          }

          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            color-adjust: exact;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 8.5pt;
            color: #000;
            background: #fff;
          }

          /* ================= PAGE BREAK CONTROLS ================= */
          .print-header,
          .from-to,
          .info-card {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .materials-table thead {
            display: table-header-group;
          }

          .materials-table tr {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .materials-footer {
            page-break-inside: avoid;
            break-inside: avoid;
            page-break-before: avoid;
            break-before: avoid;
          }

          /* ================= CONTENT ================= */

          /* ── Header ── */
          .print-header {
            display: table;
            width: 100%;
            padding-bottom: 10px;
            margin-bottom: 16px;
            border-bottom: 2px solid #1a1a1a;
          }

          .print-header__cell {
            display: table-cell;
            vertical-align: bottom;
          }

          .print-header__company {
            font-size: 18px;
            font-weight: bold;
            color: #111827;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin: 0;
          }

          .print-header__title {
            font-size: 14px;
            font-weight: 600;
            color: #1f2937;
            margin-top: 2px;
            margin-bottom: 0;
          }

          /* ── From / To ── */
          .from-to {
            border: 0.75px solid #1a1a1a;
            border-radius: 4px;
            padding: 8px 16px;
            display: table;
            width: 100%;
            box-sizing: border-box;
            margin-bottom: 16px;
          }

          .from-to__cell {
            display: table-cell;
            width: 50%;
          }

          .from-to__cell--arrow {
            display: table-cell;
            width: 10px;
            text-align: center;
            vertical-align: middle;
            color: #374151;
            font-size: 16px;
          }

          .from-to__cell--right {
            text-align: right;
          }

          /* ── Info Card ── */
          .info-card {
            border: 1px solid #1a1a1a;
            border-radius: 4px;
            overflow: hidden;
            margin-bottom: 16px;
          }

          .info-card__product-header {
            display: table;
            width: 100%;
            background-color: #f9fafb;
            border-bottom: 0.75px solid #1a1a1a;
            padding: 8px 12px;
            box-sizing: border-box;
          }

          .info-card__product-label {
            font-size: 10px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            color: #1a1a1a;
            white-space: nowrap;
          }

          .info-card__product-name {
            font-size: 14px;
            font-weight: bold;
            color: #374151;
            margin-left: 12px;
          }

          .info-card__row {
            display: table;
            width: 100%;
            box-sizing: border-box;
          }

          .info-card__row--bordered {
            border-bottom: 0.75px solid #1a1a1a;
          }

          .info-card__col {
            display: table-cell;
            width: 25%;
            padding: 8px 12px;
            border-right: 0.75px solid #1a1a1a;
          }

          .info-card__col--no-border {
            border-right: none;
          }

          .info-card__col--half {
            width: 50%;
            border-right: none;
          }

          /* ── Field Label & Value ── */
          .field-label {
            font-size: 10px;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            color: #1a1a1a;
            margin-bottom: 2px;
            font-weight: 600;
          }

          .field-value {
            font-size: 13px;
            font-weight: 600;
            color: #1f2937;
            margin: 0;
          }

          .field-value--muted {
            font-size: 13px;
            color: #6b7280;
            font-weight: 400;
            margin: 0;
          }

          /* ── Materials Table ── */
          .materials-card {
            border: none;
          }

          .materials-table {
            width: 100%;
            font-size: 11px;
            border-collapse: collapse;
          }

          .materials-table thead tr {
            background-color: #f3f4f6;
          }

          .materials-table thead th {
            border-top: 0.75px solid #1a1a1a;
            border-bottom: 0.75px solid #1a1a1a;
          }

          .materials-table thead th:first-child {
            border-left: 0.75px solid #1a1a1a;
          }

          .materials-table thead th:last-child {
            border-right: 0.75px solid #1a1a1a;
          }

          .materials-table th {
            padding: 8px 12px;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            color: #1a1a1a;
            font-weight: bold;
          }

          .materials-table th:nth-child(1) { text-align: left; width: 50%; }
          .materials-table th:nth-child(2) { text-align: left; width: 16%; }
          .materials-table th:nth-child(3) { text-align: right; width: 18%; }
          .materials-table th:nth-child(4) { text-align: right; width: 16%; }

          .materials-table tbody td {
            border-bottom: 0.75px solid #1a1a1a;
            background-color: #ffffff;
          }

          .materials-table tbody td:first-child {
            border-left: 0.75px solid #1a1a1a;
          }

          .materials-table tbody td:last-child {
            border-right: 0.75px solid #1a1a1a;
          }

          .materials-table td {
            font-size: 11px;
            font-weight: 600;
            line-height: 1.6;
            padding: 6px 12px;
            color: #1a1a1a;
          }

          .materials-table td:nth-child(1) { font-weight: 600; }
          .materials-table td:nth-child(2) { font-weight: 600; letter-spacing: 0.05em; }
          .materials-table td:nth-child(3) { text-align: right; font-weight: 600; }
          .materials-table td:nth-child(4) { text-align: right; font-weight: 600; }

          .materials-table .no-records td {
            text-align: center;
            padding: 24px;
            color: #6b7280;
            font-size: 14px;
          }

          /* ── Table Footer (Weights) ── */
          .materials-footer {
            overflow: hidden;
            border-left: 0.75px solid #1a1a1a;
            border-right: 0.75px solid #1a1a1a;
            border-bottom: 0.75px solid #1a1a1a;
          }

          .materials-footer__row {
            display: table;
            width: 100%;
          }

          .materials-footer__spacer {
            display: table-cell;
          }

          .materials-footer__cell {
            display: table-cell;
            padding: 10px 20px;
            border-left: 0.75px solid #1a1a1a;
            min-width: 180px;
            width: 180px;
          }

          .materials-footer__label {
            font-size: 10px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            color: #1a1a1a;
            margin-bottom: 4px;
          }

          .materials-footer__value {
            font-size: 12px;
            font-weight: bold;
            color: #111827;
            margin: 0;
          }
        </style>
      </head>

      <body>

        <div class="print-body">
          ${content}
        </div>

      </body>
    </html>
  `);

  iframeDoc.close();

  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  }, 500);
};